export default "__VITE_ASSET__dc96cc71__"